import { atomWithLocalStorage } from 'lib/jotai/atomWithLocalStorage';

export const savedChartAtom = atomWithLocalStorage('saved_chart', '');
